'use client';

import { useEffect } from 'react';


export function NewsletterSubscribe() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//js-eu1.hsforms.net/forms/embed/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      // @ts-ignore
      if (window.hbspt) {
        // @ts-ignore
        window.hbspt.forms.create({
          region: "eu1",
          portalId: "26189152",
          formId: "77899865-ca58-462a-a70d-85a5d3269250",
          target: '#hubspot-form'
        })
      }
    });
  }, []);
  return (
    <>
      <div id="hubspot-form" />
    </>
  )
}